
<template>
  <div class="flex" :style="'width:880px;margin:10px auto;padding:20px;background-color:' + value.backgroundColor.hex + ';'">
    <div style="margin-right:10px;flex: 1;">
      <textarea v-model="value.quote" placeholder="Enter a quote..." style="width:100%;height:120px;"></textarea>
      <slider-picker v-model="value.backgroundColor" style="margin-top:10px;margin-bottom:10px;" />
      <input v-model="value.backgroundColor.hex" placeholder="Hex colour" />
    </div>
    <div style="flex: 3;">
      <froala-editor v-model="value.wysiwyg" style="width:100%;margin:0;min-height: 100%;"></froala-editor>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FroalaEditor from "./Froala";
import { Slider } from 'vue-color'

export default {
  components: { FroalaEditor, 'slider-picker': Slider},
  data: function() {
    return {
      
    }
  },
  created() {
    if(!this.value.backgroundColor) Vue.set(this.value,"backgroundColor", {hex:"#fff"});
  },
  props:{
      value:{
          type: Object,
          required:true
      },
  }
  
}
</script>
<style>
.image-uploader {
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background-color: rgba(0,0,0,0.6);
  justify-content:center;
  align-items: center;
  display:none;
}
.image-parent:hover .image-uploader {
  display:block;
  display:flex;
}
</style>
<style scoped>
img {
  height: 400px;
  width: 100%;
  object-fit: cover;
}
.image-parent {
  position:relative;
}


input {
  width:100%;
}

</style>


// WEBPACK FOOTER //
// FeaturedQuote.vue?20fffe7a